/**
 * @generated SignedSource<<070c4d8500af0386bc1b685ce3fc4214>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useIframeMessagesSceneQuery$variables = {
  productId: string;
};
export type useIframeMessagesSceneQuery$data = {
  readonly model: {
    readonly scenes: ReadonlyArray<{
      readonly sceneID: any;
    }>;
  } | null;
};
export type useIframeMessagesSceneQuery = {
  response: useIframeMessagesSceneQuery$data;
  variables: useIframeMessagesSceneQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "productId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelScene",
  "kind": "LinkedField",
  "name": "scenes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sceneID",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useIframeMessagesSceneQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useIframeMessagesSceneQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "de955d1d2a49e03652e6eee0aef163a9",
    "id": null,
    "metadata": {},
    "name": "useIframeMessagesSceneQuery",
    "operationKind": "query",
    "text": "query useIframeMessagesSceneQuery(\n  $productId: ID!\n) {\n  model(id: $productId) {\n    scenes {\n      sceneID\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ca4c64c143a72363ac93444a7c9f02b";

export default node;
